import { FlatList as NbFlatList } from 'native-base';

import { addWithConfig } from '../../utils';

export const FlatList = NbFlatList;

export default addWithConfig(FlatList);
